// extracted by mini-css-extract-plugin
export default {"container":"SurveySelector_container__GBkm-","description":"SurveySelector_description__tpXvn","warningText":"SurveySelector_warningText__klemZ"};